<template>
  <div>
    <InsuRestrictTable />
    <section
      v-if="products"
      class="insu-prod-wrapper"
    >
      <div class="container">
        <p class="mb-m queryTips">
          您的旅遊天數共
          <span>{{ tips.totalDays }}</span> 天，
          <span>{{ tips.premiumLabel }}</span>保額，找到
          <span>{{ prodsCount }}</span> 個方案，
          請選擇您想要投保的方案後，點擊下一步
        </p>
        <template v-if="prodsCount > 0">
          <InsuProduct
            v-model="selectedInsu"
            v-bind="{triggerModal, loading}"
            :prods="products.travelInsu"
            :triggerScrollToProd="$attrs.triggerScrollToProd"
            title="旅平險方案"
            reset
            @input="handleSelect"
          />
          <div class="text-right">
            <Button
              v-show="hasSelected"
              class="btn-m btn-primary btn-shopping"
              :loading="loading"
              :disabled="!hasSelected"
              @click="handlePagePurchase"
            >
              <span v-if="!loading">下一步</span>
              <span v-else>請稍候</span>
            </Button>
          </div>
        </template>
        <template v-else>
          <ProdNotFound :triggerScrollToProd="$attrs.triggerScrollToProd" />
        </template>
      </div>
    </section>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex';
  import { Button } from 'iview';
  import InsuRestrictTable from '@/components/tables/InsuRestrictTable';
  import InsuProduct from '@/components/insurance/InsuProduct';
  import ProdNotFound from '@/components/insurance/ProdNotFound';
  import { SELECT_INSU_MUTATION, RESET_SELECTED_MUTATION } from '@/store/modules/insurance/constants';

  export default {
    inheritAttrs: false,
    components: { InsuRestrictTable, InsuProduct, ProdNotFound, Button },
    props: {
      type: {
        type: String,
        default: null
      },
      hasSelected: {
        type: Boolean,
        default: null
      },
      products: {
        type: Object,
        default: null
      },
      prodsCount: {
        type: Number,
        default: 0
      },
      tips: {
        type: Object,
        default: null
      },
      loading: {
        type: Boolean,
        default: false
      },
      triggerModal: {
        type: Function,
        default: () => {}
      }
    },
    data() {
      return {
        selectedInsu: null,
      };
    },
    methods: {
      ...mapMutations([RESET_SELECTED_MUTATION, SELECT_INSU_MUTATION]),
      handleSelect(val) {
        if (!val) {
          this.selectedInsu = null;
          return this.RESET_SELECTED_MUTATION();
        }
        return this.SELECT_INSU_MUTATION([val]);
      },
      handlePagePurchase() {
        const { selectedInsu } = this;
        if (!selectedInsu) return;
        this.triggerModal([selectedInsu]);
      }
    }
  };
</script>
